import axios from 'axios';
import VueAxios from 'vue-axios';
import { createApp } from 'vue';
import router from './router';
import App from './App.vue';
import './input.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { getDocumentTitle } from './navigation/itsaveNavigation';
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

library.add(faArrowUp,faArrowDown);

const app = createApp(App);

document.title = getDocumentTitle();
router.afterEach((to) => {
  const [pathname, query = ''] = to.fullPath.split('?');
  document.title = getDocumentTitle(pathname, query ? `?${query}` : '');
});

app.component('font-awesome-icon', FontAwesomeIcon);
app.use(router);
app.mount('#app');
app.use(VueAxios, axios);
//createApp(App).mount('#app')
